/*require('./../../style/session-list.less');*/
import Vm from '../sw-component/utils/Vm'; 
var vm_template = require('./../sw-component/sw/session-list.sw');
var Component = require('./../Component'),
  $ = require('jQuery'),
  template = require('../../template/session-list.html'),
  ContactSessionItem = require('./SessionItem'),
  dispatcher = require('./../../global/dispatcher'),
  ContactStatus = require('./../../constant/ContactStatus'),
  ActionType = require('./../../constant/ActionType'),
  Loading = require('./../Loading'),
  strToNumCompare = require('./../../../lib/util').strToNumCompare;

var createkey = function (session) {
  if (session.group) {
    return 'group-' + session.group.id;
  }
  else if (session.contact) {
    var baseKey = 'contact-' + session.contact.user_id + '@' + session.contact.user_source;
    var shopKey = session.contact.shop_id + '@' + session.contact.shop_source;
    return session.contact.shop_id && session.contact.shop_source ? baseKey + '@@' + shopKey : baseKey;
  }
  return null;
};

class SessionList extends Vm {
  constructor (options) {
    var defaults = {
      template: template,
      getMoreSession: function (cb) {
        cb([], false);
      }
    };

    $.extend(defaults, options);
    super(defaults);
    //排序
    this._oldOrder = [];
    this._newOrder = [];
    // 加载session
    this._loadingSession = false;
    this._moreSession = true;
    this._render = false;
    this._rendered = false;
    //scroll
    this._currentSession = null;
    this._lastMsg = null;

    (function (self) {
      dispatcher.register(function (action) {
        switch (action.type) {
          case ActionType.SESSION_SELF_CHANGE:
            var session = action.data;
            var key = createkey(session);
            if (session.checked && self._children[key]) {
              self._currentSession = key;
              self.scrollToTarget(key);
            }
            self.updateContactSession(session);
            break;
          case ActionType.CONTACT_ONLINE_CHANGE:
            self.setOnline(action.data);
            break;
          default:
            break;
        }
      });
    })(this);
  
    (function (self) {
      if (self._options && self._options.is_vm) {

      } else {
        var loading = new Loading();
        self.getElement().append(loading.getElement());
        self._children["session-loading"] = loading;
      }
      self.addMoreSession();
      // IE7
      self.getElement().css({
        "marginTop": 0
      });
    })(this);
  }

  components () {
    return {
        'session-item': ContactSessionItem,
        'loading': Loading
    }
  }

  vm_template () {
    return vm_template();
  } 

  vm_data() {
    return {
      sessions: []
    }
  }

  vm_methods() {
    return {
      createkey
    }
  }

  setOnline(contact) {
    var self = this;
    var sessionKey = 'contact-' + contact.user_id + '@' + contact.user_source;
    if (this._children[sessionKey]) {
      this._children[sessionKey].setData({ is_online: contact.is_online });
    }
    $.each(this._children, function (contactKey, item) {
      if (contactKey.indexOf('@@') !== -1 && contactKey.split('@@')[0] == sessionKey) {
        self._children[contactKey].setData({ is_online: contact.is_online });
      } else if (contactKey.indexOf('group') !== -1 && item._data && item._data.session && item._data.session.children) {
        $.each(item._data.session.children, function (index, anonymousSession) {
          if (anonymousSession.contact && anonymousSession.contact.user_id == contact.user_id && anonymousSession.contact.user_source == contact.user_source) {
            item._data.session.children[index].is_online = contact.is_online;
          }
        })
      }
    })
  }

  empty() {
    var self = this;
    $.each(this._children, function (key, value) {
      value.destroy();
      delete self._children[key];
    });
  }

  // 添加、更新会话（排序）
  setSessions(sessions, callback) {
    var self = this;
    var currentsession = null;
    var msg_id = null;
    if (self._options && self._options.is_vm) {
      self.setData({
        sessions
      }, false, function() {
        $.each(sessions, function (index, session) {
          var key = createkey(session);
          if (self._children[key]) {
            if (session.checked) {
              currentsession = key;
              msg_id = session.msg ? session.msg.msg_id : null;
            }
            return;
          }
        });
        if (self._currentSession === currentsession && currentsession) {
          if (strToNumCompare(self._lastMsg, msg_id) != 0) {
            self._lastMsg = msg_id;
            self.scrollToTarget(currentsession);
          }
        } else {
          self._currentSession = currentsession;
        }
        self._children["session-loading"] && self._children["session-loading"].close();
        typeof callback === 'function' && callback();
      });
    } else {
      $.each(sessions, function (index, session) {
        var key = createkey(session);
        if (self._children[key]) {
          self.reorderSession(key);
          self._children[key].setSession(session);
          if (session.checked) {
            currentsession = key;
            msg_id = session.msg ? session.msg.msg_id : null;
          }
          return;
        }
        var comp = new ContactSessionItem({
          key
        });
    
        if (comp) {
          self._children[key] = comp;
          comp.setSession(session);
          self._element.append(comp.getElement());
        }
        self.reorderSession(key);
    
      });
    
      if (this._currentSession === currentsession && currentsession) {
        if (strToNumCompare(this._lastMsg, msg_id) != 0) {
          this._lastMsg = msg_id;
          this.scrollToTarget(currentsession);
        }
      } else {
        this._currentSession = currentsession;
      }

      this._children["session-loading"] && this._children["session-loading"].close();
      this.deleteSpareSession();
      typeof callback === 'function' && callback();
    }
  }


  // 更新会话
  updateContactSession(session) {
    var key = createkey(session);
    var comp = this._children[key];
    if (comp) {
      comp.setSession(session);
    }
  };

  // 删除无效会话
  deleteSpareSession() {
    if (this._render && this._rendered) {
      this._render = false;
      this._rendered = false;
      this.addMoreSession();
    }
    var self = this;
    var oldOrder = this._oldOrder;
    var to_be_deleted = [];
    if (this._newOrder.length < oldOrder.length) {
      var spareArray = oldOrder.slice(this._newOrder.length);
      $.each(spareArray, function (index, key) {
        self.remove(key);
        to_be_deleted.push(key);
      });
    }
    this._oldOrder = this._newOrder;
    this._newOrder = [];
  };

  // session重新排序
  reorderSession(key) {
    var oldOrder = this._oldOrder;
    var indexNew = $.inArray(key, this._newOrder);
    if (indexNew != "-1") {
      return false
    }
    this._newOrder.push(key);
    var indexOld = $.inArray(key, oldOrder);
    var comp = this._children[key];
    if (indexOld != "-1") {
      oldOrder.splice(indexOld, 1);
    }
    oldOrder.splice(this._newOrder.length - 1, 0, key);
    if (this._newOrder.length < 2) {
      this.getElement().prepend(comp.getElement());
    } else {
      this._children[this._newOrder[this._newOrder.length - 2]].after(this._children[key]);
    }
  };

  // 删除session
  remove(key) {
    if (this._children[key]) {
      this._children[key].destroy();
    }
    delete this._children[key];
  };

  // 滚动加载更多session
  addLoading() {
    var marginTop = this.getElement().outerHeight() - this.getElement().parent().outerHeight();
    if (!this._moreSession || this._loadingSession) {
      return false;
    }
    var self = this;
    this._loadingSession = true;
    this._children["session-loading"] && this._children["session-loading"].open();
    this.getElement().css("margin-top", -(marginTop + 25));
    this._options.getMoreSession(function (sessionlist, have_more) {
      self._children["session-loading"] && self._children["session-loading"].close();
      self._loadingSession = false;
      if (!have_more || sessionlist.length === 0) {
        self._moreSession = false;
        self.getElement().css({
          "marginTop": -marginTop
        })
      }
    });
  };

  // 循环检查是否还有更多session
  addMoreSession() {
    (function addMore(self, maxCount, counter) {
      if (self._render || (counter++ >= maxCount)) {
        self._rendered = true;
        return false
      }
      self._render = true;
      var listWrapHeight = self.getElement().parent().height();
      var listHeight = self.getElement().height();
      if (listHeight > listWrapHeight) {
        self._render = false;
        self._rendered = true;
        return false;
      }
      self._options.getMoreSession(function (data, have_more) {
        if (have_more) {
          if (!data.length) {
            self._render = false;
          }
          addMore(self, maxCount, counter);
        } else {
          if (data.length === 0 && self._oldOrder.length === 0) {
            self._children["session-loading"].close();
            self.triggerEvent("voidlist");
          }
          self._render = false;
          self._rendered = true;
          return false;
        }
      });
    })(this, 100, 0);
  };

  //滚动到指定session
  scrollToTarget(key) {
    var scroll;
    var sessionTop = this._children[key].getElement().position().top;
    var wrapHeight = this.getElement().parent().height();

    if (sessionTop >=
      0 && sessionTop <= wrapHeight - this._children[key].getElement().height()
    ) {
      scroll = false
    }
    else if (sessionTop < 0) {
      scroll = sessionTop;
    } else {
      scroll = this._children[key].getElement().height() - (wrapHeight - sessionTop);
    }
    this.triggerEvent("setScrollTop", scroll);
  };
  
}

module.exports = SessionList;